import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4bad500"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rlhistory-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "姓名：", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "身份证：", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "设备时间：", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createVNode(_component_van_pull_refresh, {
      modelValue: _ctx.refreshing,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.refreshing) = $event)),
      onRefresh: _ctx.onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: _ctx.loading,
          "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loading) = $event)),
          finished: _ctx.finished,
          "finished-text": "没有更多了",
          "loading-text": "正在加载,请稍后..",
          onLoad: _ctx.onLoad
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listData, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "list",
                key: index
              }, [
                _createElementVNode("div", null, [
                  (item.fileUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: item.fileUrl
                      }, null, 8, _hoisted_2))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: require('@/assets/inspection/zhanwei.svg')
                      }, null, 8, _hoisted_3))
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _hoisted_4,
                    _createElementVNode("span", null, _toDisplayString(item.driverName ? item.driverName : "暂无信息"), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_5,
                    _createElementVNode("span", null, _toDisplayString(item.driverNo ? item.driverNo : "暂无信息"), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_6,
                    _createElementVNode("span", null, _toDisplayString(item.deviceTime ? item.deviceTime : "暂无信息"), 1)
                  ])
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "finished", "onLoad"])
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"])
  ]))
}